import 'normalize.css/normalize.css';
import 'vuetify/dist/vuetify.min.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
// import './styles/main.scss'; // in App.vue because we want to load after vuetify theme

import Vue from 'vue';
import Amplify from '@aws-amplify/core';
import vuelidate from 'vuelidate';
import vuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor';
import Draggable from 'vuedraggable';
import checkMobileDeviceMixin from '@/mixins/checkMobileDeviceMixin';
import attachmentsPreviewMixin from '@/mixins/attachmentsPreviewMixin';
import PortalVue from 'portal-vue';
import permission from '@/store/modules/permission';
import vuetify from './plugins/vuetify';
import { i18n } from './i18n';

import App from './App.vue';
import router from './router';
import createStore from './store';

import './router/permission';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);
Vue.component('draggable', Draggable);
Vue.use(vuelidate);
Vue.mixin(checkMobileDeviceMixin);
Vue.mixin(attachmentsPreviewMixin);
Vue.use(vuelidateErrorExtractor, {
  /**
   * Optionally provide the template in the configuration.
   * or register like so Vue.component("FormField", templates.singleErrorExtractor.foundation6)
   */
  template: templates.singleErrorExtractor.foundation6, // you can also pass your own custom template
  messages: { required: 'The {attribute} field is required' }, // error messages to use
  attributes: { // maps form keys to actual field names
    email: 'Email',
    first_name: 'First name',
    last_name: 'Last name',
  },
});
Vue.use(PortalVue);

const store = createStore();
store.registerModule('permission', permission);

new Vue({
  components: { },
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
